// extracted by mini-css-extract-plugin
module.exports = {"AbilityBox":"AbilityBox_AbilityBox__2oSFk","Type":"AbilityBox_Type__z4JTV","Value":"AbilityBox_Value__b5cZm","Hidden":"AbilityBox_Hidden__1d9a3"};